import i18n from "i18next";

const LANGUAGE_KEYS = ["pt-BR", "pt", "en"];

export const deepMerge = (base, override) => {
  if (!override || typeof override !== "object" || Array.isArray(override)) {
    return override === undefined ? base : override;
  }
  const result = { ...(base || {}) };
  Object.keys(override).forEach(key => {
    const baseVal = result[key];
    const overrideVal = override[key];
    if (
      baseVal &&
      typeof baseVal === "object" &&
      !Array.isArray(baseVal) &&
      overrideVal &&
      typeof overrideVal === "object" &&
      !Array.isArray(overrideVal)
    ) {
      result[key] = deepMerge(baseVal, overrideVal);
    } else {
      result[key] = overrideVal;
    }
  });
  return result;
};

export const isLanguageCatalog = source => {
  if (!source || typeof source !== "object" || Array.isArray(source)) {
    return false;
  }
  return LANGUAGE_KEYS.some(
    lng =>
      source[lng] &&
      typeof source[lng] === "object" &&
      !Array.isArray(source[lng])
  );
};

/**
 * Applies a catalog shaped as { "pt-BR": {...}, en: {...} }.
 * Optional overrides deep-merge on top of the base catalog (per-client white-label).
 */
export const applyI18nCatalog = (catalog, overrides) => {
  if (!catalog || typeof catalog !== "object") {
    return;
  }
  const merged =
    overrides && isLanguageCatalog(overrides)
      ? deepMerge(catalog, overrides)
      : catalog;
  Object.keys(merged).forEach(lng => {
    const bundle = merged[lng];
    if (!bundle || typeof bundle !== "object") {
      return;
    }
    i18n.addResourceBundle(lng, "translation", bundle, true, true);
    if (lng === "pt-BR" && !merged.pt) {
      i18n.addResourceBundle("pt", "translation", bundle, true, true);
    }
  });
};

export default applyI18nCatalog;
